<ng-template [ngIf]="show">
	<h1 class="sr-only">Teleforum</h1>
		<a [routerLink]="urlWelcomeBoard"  appTooltip="Torna alla home" placement="bottom" [appTooltipEnabled]="true">
			<img src="img/logo.png" alt="Teleforum logo">
			<span class="sr-only">Torna alla home di Teleforum</span>
		</a>
	<nav header_nav aria-label="Navigazione principale"></nav>
</ng-template>